import metrics, { IMetric } from 'maps/metrics';

const thisWeekToDate = metrics['performance_this_week_to_date'];
const lastWeek = metrics['performance_last_week'];
const lastWeekRange = metrics['performance_last_week_range'];
const rtd = metrics['performance_rtd'];
const lastWeekToDate = metrics['performance_last_week_to_date'];
const thisWeekToDateRange = metrics['this_week_to_date_range'];
const lastLastWeek = metrics['performance_last_last_week'];

/**
 * This function constructs the array needed to populate the
 * sorting metric dropdown on mobile.
 *
 * @param {String} browseEntityType to retrieve the label for entity name column/dropdown option
 * @param {String} tableHeadersType to know what set of table headers should be used
 * @returns {Array} the options the user can sort by.
 */
const getMobileSortingOptions = (
  browseEntityType: string,
  tableHeadersType?: string
): IMetric[] => {
  if (tableHeadersType === 'standard') {
    const res = [
      {
        label: `${browseEntityType} (A-Z)`,
        value: 'displayName',
        key: 'displayName',
        sortOrder: 'asc',
      },
      {
        label: `${browseEntityType} (Z-A)`,
        value: 'displayName',
        key: 'displayName',
        sortOrder: 'desc',
      },
      {
        ...thisWeekToDate,
        label: 'Week to Date (Low to High)',
        withoutSubLabel: true,
        sortOrder: 'asc',
      },
      {
        ...thisWeekToDate,
        label: 'Week to Date (High to Low)',
        withoutSubLabel: true,
        sortOrder: 'desc',
      },
      {
        ...thisWeekToDateRange,
        label: 'WTD Change (Low to High)',
        withoutSubLabel: true,
        sortOrder: 'asc',
      },
      {
        ...thisWeekToDateRange,
        label: 'WTD Change (High to Low)',
        withoutSubLabel: true,
        sortOrder: 'desc',
      },
      {
        ...lastWeekToDate,
        label: 'Last Week to Date (Low to High)',
        withoutSubLabel: true,
        sortOrder: 'asc',
      },
      {
        ...lastWeekToDate,
        label: 'Last Week to Date (High to Low)',
        withoutSubLabel: true,
        sortOrder: 'desc',
      },
      {
        ...lastWeek,
        label: 'Last Full Week (Low to High)',
        withoutSubLabel: true,
        sortOrder: 'asc',
      },
      {
        ...lastWeek,
        label: 'Last Full Week (High to Low)',
        withoutSubLabel: true,
        sortOrder: 'desc',
      },
      {
        ...lastWeekRange,
        label: 'LFW Change (Low to High)',
        withoutSubLabel: true,
        sortOrder: 'asc',
      },
      {
        ...lastWeekRange,
        label: 'LFW Change (High to Low)',
        withoutSubLabel: true,
        sortOrder: 'desc',
      },
      {
        ...lastLastWeek,
        label: '2 Full Weeks Ago (Low to High)',
        withoutSubLabel: true,
        sortOrder: 'asc',
      },
      {
        ...lastLastWeek,
        label: '2 Full Weeks Ago (High to Low)',
        withoutSubLabel: true,
        sortOrder: 'desc',
      },
      { ...rtd, label: 'Release to Date (Low to High)', sortOrder: 'asc' },
      { ...rtd, label: 'Release to Date (High to Low)', sortOrder: 'desc' },
    ];
    if (browseEntityType.match('track|release|album')) {
      res.splice(2, 0, {
        label: `This week to date (New to Old)`,
        value: 'performance_this_week_to_date',
        key: 'performance_this_week_to_date',
        sortOrder: 'desc',
      });
      res.splice(2, 0, {
        label: `This week to date (Old to New)`,
        value: 'performance_this_week_to_date',
        key: 'performance_this_week_to_date',
        sortOrder: 'asc',
      });
    }
    return res;
  }
  if (tableHeadersType === 'toplists') {
    return [
      {
        label: `${browseEntityType} (A-Z)`,
        value: 'displayName',
        key: 'displayName',
        sortOrder: 'asc',
      },
      {
        label: `${browseEntityType} (Z-A)`,
        value: 'displayName',
        key: 'displayName',
        sortOrder: 'desc',
      },
      {
        ...thisWeekToDate,
        label: 'Week to Date (Low to High)',
        withoutSubLabel: true,
        sortOrder: 'asc',
      },
      {
        ...thisWeekToDate,
        label: 'Week to Date (High to Low)',
        withoutSubLabel: true,
        sortOrder: 'desc',
      },
      {
        ...thisWeekToDateRange,
        label: 'WTD Change (Low to High)',
        withoutSubLabel: true,
        sortOrder: 'asc',
      },
      {
        ...thisWeekToDateRange,
        label: 'WTD Change (High to Low)',
        withoutSubLabel: true,
        sortOrder: 'desc',
      },
      {
        ...lastWeekToDate,
        label: 'Last Week to Date (Low to High)',
        withoutSubLabel: true,
        sortOrder: 'asc',
      },
      {
        ...lastWeekToDate,
        label: 'Last Week to Date (High to Low)',
        withoutSubLabel: true,
        sortOrder: 'desc',
      },
    ];
  }

  return [
    {
      label: `${browseEntityType} name`,
      value: 'displayName',
      key: 'displayName',
    },
    thisWeekToDate,
    {
      ...metrics[thisWeekToDate.change as string],
      label: thisWeekToDate.label,
    },
    lastWeek,
    { ...metrics[lastWeek.change as string], label: lastWeek.label },
    rtd,
  ];
};
export default getMobileSortingOptions;
